import Immutable from "immutable";

const LOAD = "repots/LOAD";

const LOAD_REPORT_CARE_SUCCESS = "repots/LOAD_REPORT_CARE_SUCCESS";
const LOAD_DOCTOR_WORK_HISTORY_SUCCESS =
  "repots/LOAD_DOCTOR_WORK_HISTORY_SUCCESS";

const LOAD_FAIL = "repots/LOAD_FAIL";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  reports: null,
  doctorWorkHistory: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_REPORT_CARE_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("reports", action.reports);

    case LOAD_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error);
    case LOAD_DOCTOR_WORK_HISTORY_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("doctorWorkHistory", action.doctorWorkHistory);

    default:
      return state;
  }
}

export const getWorkHistoryByDoctorId =
  (id) => async (dispatch, getState, api) => {
    try {
      let res = await api.get("/report/getDoctorWorkHistory/" + id);
      dispatch({
        type: LOAD_DOCTOR_WORK_HISTORY_SUCCESS,
        doctorWorkHistory: res,
      });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };

export const getScheduleChangeComments =
  (params = {}) => async (dispatch, getState, api) => {
    try {
      return await api.get(
        "/report/scheduleChangeComments/" +
          encodeURIComponent(JSON.stringify(params)),
      );
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
      return null;
    }
  };
